import IconTextList from './iconTextList';

export default IconTextList;
